module.exports = __webpack_public_path__ + "static/img/1-1.3e4e3f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/eng/1-1.png
// module id = 1V8x
// module chunks = 0